
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect } from '@/components';
import { useQuestBoostAdd } from '@/modules/quest/boost/model/add';
import { timeUnits } from '@/common/utils/helpers';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';

export default defineComponent({
    name: ROUTE_NAME_QUEST.BOOST.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect },
    setup() {
        const { model, v$, fetch, actions, iapOptions } = useQuestBoostAdd();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, actions, iapOptions, timeUnits };
    }
});
